import store from "@/store";
import moment from "moment";

// helper functions for checking if a date is a closed period

export function isClosedThatDay(date) {
	const openClosedDays = store.getters["user/openClosedDays"],
		closedDay = openClosedDays.find(closedDay => {
			const START = moment(closedDay.start_date);
			if (closedDay.end_date)
				return moment(date).isBetween(START, closedDay.end_date, "day", "[]");
			return moment(date) >= START;
		});

	if (!closedDay) {
		// No closed days found for date, in that case the outlet is not closed
		return false;
	}

	return !closedDay.days.includes(moment(date).isoWeekday());
}


export function isInExceptionalDays(date) {
	const exceptionalClosedDays = store.getters["user/exceptionalClosedDays"],
		closedDay = exceptionalClosedDays.find(closedDay => {
			const START = closedDay.start_date,
				END = closedDay.end_date,

				/*
				 *  A [ indicates inclusion of a value, see moment docs
				 * https://momentjscom.readthedocs.io/en/latest/moment/05-query/06-is-between/
				 */
				INCLUSIVITY = "[]";

			return moment(date).isBetween(START, END, "day", INCLUSIVITY);
		});

	return Boolean(closedDay);
}
